import Reveal from "@/components/escape21/Reveal";

const ProfileProof = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-5xl">
      <Reveal className="text-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          prova de perfil
        </span>
        <h2 className="mx-auto mt-4 max-w-2xl text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          não é sorte de um vídeo. é <span className="e21-serif text-green-400">volume</span> e consistência.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/55 sm:text-lg">
          conteúdo saindo todo dia, feed cheio e um perfil que segura a atenção de
          quem chega. é isso que sustenta o alcance.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2">
        <Reveal>
          <img
            src="/portfolio/feed-geral.jpg"
            alt="feed do instagram — grid de posts"
            loading="lazy"
            className="w-full rounded-2xl border border-white/10 bg-white/5"
          />
          <p className="mt-3 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
            o feed
          </p>
        </Reveal>
        <Reveal delay={100}>
          <img
            src="/portfolio/perfil-geral.jpg"
            alt="print do perfil do instagram"
            loading="lazy"
            className="w-full rounded-2xl border border-white/10 bg-white/5"
          />
          <p className="mt-3 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
            o perfil
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default ProfileProof;
